<template>
  <div>
    {{ trackingStatus2Name(trackingStatus, 'Created') }}
  </div>
</template>

<script lang="ts">
import type { AdjustedShipment, Shipment } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { trackingStatus2Name } from '@/services/Helpers'

export default defineComponent({
  name: 'TrackingStatusCell',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const trackingStatus: ComputedRef<string> = computed(() => {
      const shipments = [...(props.shipment.shipments || [])].sort(
        (a: AdjustedShipment, b: AdjustedShipment) => b.runningNumber - a.runningNumber,
      )
      return shipments[0]?.lastTrackingEventStatus || shipments[1]?.lastTrackingEventStatus || ''
    })

    return {
      trackingStatus,
      trackingStatus2Name,
    }
  },
})
</script>
